import type { BookingSummary } from '../../types/storefront'

const key = (slug: string) => `vega.booking.last.${slug}`

/** The confirmation screen normally reads the booking off the navigation state.
 *  Stashing a copy means a refresh — or a shared link opened again on the same
 *  tab — still shows the booking code instead of an empty page. */
export function rememberBooking(slug: string, booking: BookingSummary) {
  try {
    sessionStorage.setItem(key(slug), JSON.stringify(booking))
  } catch {
    // Storage unavailable: the in-memory navigation state still carries it.
  }
}

export function readRememberedBooking(slug: string): BookingSummary | null {
  try {
    const raw = sessionStorage.getItem(key(slug))
    if (!raw) return null
    const parsed: unknown = JSON.parse(raw)
    if (parsed && typeof parsed === 'object' && 'code' in parsed) return parsed as BookingSummary
  } catch {
    // Corrupt or blocked: treated the same as "no booking to show".
  }
  return null
}
